import { render, staticRenderFns } from "./cfds.vue?vue&type=template&id=81641a78"
import script from "./cfds.vue?vue&type=script&lang=js"
export * from "./cfds.vue?vue&type=script&lang=js"
import style0 from "./cfds.vue?vue&type=style&index=0&id=81641a78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports